import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, X, MessageCircle, Trophy } from "lucide-react";
import { NAV_LINKS } from "../data/mock";
import { useSite } from "../context/SiteContext";
import { fileUrl } from "../api";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { site } = useSite();
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#0a1226]/85 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <img src={site.logoUrl ? fileUrl(site.logoUrl) : "/logo.png"} alt={site.brand} className="h-10 w-10 rounded-xl object-contain shadow-lg shadow-amber-500/20" />
          <div className="leading-tight">
            <div className="text-xl md:text-2xl font-extrabold text-white font-[Poppins] tracking-tight">
              {site.brand}<span className="text-[#FFB800]">.guru</span>
            </div>
            <div className="text-[10px] text-amber-300/70 uppercase tracking-widest hidden sm:block">{t("brandTag")} {site.since}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              className={({ isActive }) =>
                `px-3.5 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive ? "text-[#FFB800] bg-white/5" : "text-slate-200 hover:text-[#FFB800] hover:bg-white/5"
                }`
              }
            >
              {t(l.key, l.label)}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <a href={site.whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold hidden md:inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm">
            <MessageCircle className="w-4 h-4" /> {t("nav.getIdNow")}
          </a>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 rounded-md text-white hover:bg-white/5" aria-label="Toggle menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#0a1226]/95">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                onClick={() => setOpen(false)}
                className={`px-3 py-2.5 rounded-md text-sm ${
                  location.pathname === l.path ? "bg-white/5 text-[#FFB800]" : "text-slate-200 hover:bg-white/5"
                }`}
              >
                {t(l.key, l.label)}
              </Link>
            ))}
            <a href={site.whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold mt-2 text-center px-4 py-2.5 rounded-lg text-sm">
              {t("nav.getIdNow")}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
